import { useEffect, useState } from "react";
import { connectLive, type WSState, type DeltaEvent, type JobEvent } from "@/lib/ws";

/**
 * useLiveStatus hält den letzten Delta-Lauf, den laufenden Job (Live aus dem
 * WS-Stream) und den WebSocket-Verbindungszustand.
 */
export function useLiveStatus() {
  const [last, setLast] = useState<DeltaEvent | null>(null);
  const [job, setJob] = useState<JobEvent | null>(null);
  const [wsState, setWsState] = useState<WSState>("connecting");

  useEffect(() => {
    const client = connectLive(
      (msg) => {
        if (msg.type === "delta") setLast(msg);
        else if (msg.type === "job") setJob(msg);
      },
      setWsState,
    );
    return () => client.close();
  }, []);

  return { last, job, wsState };
}
